import { coinbaseWallet, metaMask, walletConnect } from "wagmi/connectors";
import { http } from "viem";
import { createConfig } from "wagmi";
import { envChains, walletConnectId } from "../utils/constants";
import { VanarChain } from "./chains/vanarChain";

const supportedChain = [];

if (envChains.includes(1947) || envChains.includes(78600) || envChains.includes(2040)) {
    supportedChain.push(VanarChain);
}

const transports = supportedChain.reduce((acc, chain) => {
    acc[chain.id] = http(); // Use the `http` transport provider for each chain
    return acc;
}, {});

export const wagmiConfig = createConfig({
    multiInjectedProviderDiscovery: false,
    chains: supportedChain,
    connectors: [
        metaMask(),
        walletConnect({
            projectId: walletConnectId,
        }),
        coinbaseWallet({
            preference: {
                keysUrl: process.env.REACT_APP_COINBASE_KEYS_URL,
            },
        }),
    ],
    transports: transports,
});

